import { useState } from "react";
import TopTabs from "./TopTabs";
import ViewApplication from "./ViewApplication";
import Documents from "./Documents";
import Timeline from "./Timeline";

export default function ApplicationDetails() {
  const [activeTab, setActiveTab] = useState("View Application");

  return (
    <div className="font-inter bg-[#FBFAFD] min-h-screen p-6">
      <TopTabs activeTab={activeTab} setActiveTab={setActiveTab} />

      {activeTab === "View Application" && <ViewApplication />}
      {activeTab === "Documents" && <Documents />}
      {activeTab === "Timeline" && <Timeline />}
    </div>
  );
}
